import React from 'react';
import { observer } from 'mobx-react';
import Cursor from '../../../../../../../css/ppt-editor-cursor-global.less';
import ColorPicker from '../../../../../../frame-pc/components/color-picker';
import { browser } from '../../../../../../../slide/infrastructure/module/independent/agent/common';
import _isFunction from 'lodash/isFunction';
import { IFormatBrushManager } from '@src/slide/application/service/format-brush/core/interface';
import { IAnimBrushManager } from '@src/slide/application/service/anim-brush/core/interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

interface IPoint {
    x: number;
    y: number;
}

interface SelectViewProps {
    selectedFinished: (rect: DOMRect, point: IPoint) => void,
    style?: object,
    children: any,
    formatBrushManager?: IFormatBrushManager,
    animBrushManager?: IAnimBrushManager
    selectedElements?: IElementBaseModel[];
}

interface SelectViewState {
    displaySelectedView: boolean;
    currentPoint?: IPoint;
}

@observer
class SelectView extends React.Component<SelectViewProps, SelectViewState> {
    private isMouved = false;
    private startPoint: IPoint;
    private offsetPoint: IPoint;
    private eleRef: HTMLElement|null;
    private divRef: HTMLElement|null;

    public constructor(props) {
        super(props);
        this.state = {
            displaySelectedView: false,
        };
    }

    public render() {
        const element: JSX.Element|null|undefined = this.renderElement();


        const style = this.props.style || {
            width: '100%',
            height: '100%',
            position: 'absolute',
        };

        const className = this.getViewClassName();

        return (
            <div id="select-view" className={className} onMouseDown={this.mouseDown.bind(this)} style={style} ref={(divRef) => {
                this.divRef = divRef;
            }}>
                {this.props.children}
                {element}
            </div>
        );
    }

    private renderElement = (): JSX.Element|undefined  => {
        if (this.state.displaySelectedView && this.state.currentPoint) {
            const { currentPoint } = this.state;

            let left = this.startPoint.x - this.offsetPoint.x;
            let top = this.startPoint.y - this.offsetPoint.y;
            const width = Math.abs(currentPoint.x - this.startPoint.x);
            const height = Math.abs(currentPoint.y - this.startPoint.y);

            if (currentPoint.x < this.startPoint.x) {
                left = left - Math.abs(currentPoint.x - this.startPoint.x);
            }

            if (currentPoint.y < this.startPoint.y) {
                top = top - Math.abs(currentPoint.y - this.startPoint.y);
            }

            return <div style={{
                left,
                top,
                width,
                height,
                backgroundColor: 'darkgrey',
                position: 'absolute',
                opacity: 0.5,
                zIndex: 100001,
            }} ref={((eleRef) => {
                this.eleRef = eleRef;
            })}/>;
        }
        return undefined;
    };

    private getViewClassName = (): string => {
        const { formatBrushState: brush } = this.props.formatBrushManager || {};
        const { animBrushState } = this.props.animBrushManager || {};

        const formatTextBrush = this.getFormatTextBrush();
        const formatBrush = this.getFormatBrush();
        if (animBrushState) {
            // office 中选中的元素为动画复制来源，使用默认鼠标指针
            return this.selectedUinqueID?.includes(animBrushState.originElId) ? Cursor.normal_select : formatBrush;
        }
        if (brush?.data) {
            return brush.data === 'text' ? formatTextBrush : formatBrush;
        }

        return Cursor.normal_select;
    };

    private mouseDown(e) {
        // 鼠标左键
        if (e.nativeEvent.which === 1) {
            this.isMouved = false;

            this.offsetPoint = {
                x: this.divRef?.getBoundingClientRect().left || 0,
                y: this.divRef?.getBoundingClientRect().top || 0,
            };

            this.startPoint = {
                x: e.clientX,
                y: e.clientY,
            };

            const chartEditModalElement = document.querySelector('.slide-spread-sheet-modal');
            const isMouseOnModal = chartEditModalElement?.contains(e.nativeEvent.target);

            this.setState({ currentPoint: this.startPoint });
            if (!ColorPicker.isShown() && !isMouseOnModal) {
            // if (!ColorPicker.isShown()) {
                this.setState({ displaySelectedView: true });
            }
            document.addEventListener('mousemove', this.mouseMove);
            document.addEventListener('mouseup', this.mouseUp);
        }
    }

    private mouseMove = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.isMouved = true;

        const currentPoint = {
            x: e.clientX,
            y: e.clientY,
        };
        this.setState({ currentPoint });
    };

    private mouseUp = (e) => {
        e.preventDefault();
        e.stopPropagation();

        document.removeEventListener('mousemove', this.mouseMove);
        document.removeEventListener('mouseup', this.mouseUp);

        if (this.isMouved === true && _isFunction(this.props.selectedFinished) && this.eleRef) {
            this.props.selectedFinished(this.eleRef.getBoundingClientRect(), this.offsetPoint);
        }

        this.setState({ displaySelectedView: false });

        const { formatBrushManager, animBrushManager } = this.props;
        formatBrushManager?.onCancelBrush();
        animBrushManager?.onCancelBrush();
    };

    private getFormatBrush() {
        return browser.isIE || browser.isEdge ? Cursor.format_brush_edge : Cursor.format_brush;
    }

    private getFormatTextBrush() {
        return browser.isIE || browser.isEdge
            ? Cursor.format_text_brush_edge : Cursor.format_text_brush;
    }

    private get selectedUinqueID() {
        return this.props.selectedElements?.map(elementModel => elementModel.uniqueID);
    }
}


export default SelectView;
